(function () {
  var cleanupTimer;

  var priceSelectors =
    '.price, .product-price-without-taxes, .product-price-without-taxes-personalizado, .precio-personalizado-container, .LOP-precios-descuento-container, .lop-installments-container';

  function cleanupHiddenPriceCard(card) {
    if (!card || card.getAttribute('data-hide-price') !== 'true') return;

    var infoInner = card.querySelector('.product-card-info--inner');
    if (infoInner) {
      infoInner.querySelectorAll(priceSelectors).forEach(function (el) {
        el.remove();
      });
    }

    card.querySelectorAll('.LOP-cucarda-descuento:not(.LOP-cucarda-preventa), .LOP-cucarda-derecha').forEach(function (el) {
      el.remove();
    });

    card.querySelectorAll('.product-card--badges .badge.onsale').forEach(function (el) {
      el.remove();
    });
  }

  function cleanupHiddenPriceProductDetail(productDetail) {
    if (!productDetail || productDetail.getAttribute('data-hide-price') !== 'true') return;

    productDetail.querySelectorAll(
      '.product--price-container, ' +
        priceSelectors +
        ', .LOP-cucarda-descuento:not(.LOP-cucarda-preventa), .LOP-cucarda-precio, shopify-payment-terms, .installment, .lop-free-shipping-message'
    ).forEach(function (el) {
      el.remove();
    });

    productDetail.querySelectorAll('.product-add-to-cart-sticky--info [id^="price-"], .product-add-to-cart-sticky--info .price').forEach(function (el) {
      el.remove();
    });

    productDetail.setAttribute('data-cucardas-procesadas', 'true');
  }

  function dedupePdpTitleBlocks() {
    var inner = document.querySelector('.product-information--inner');
    if (!inner) return;

    var titleContainers = inner.querySelectorAll('.product--title-container');
    if (titleContainers.length <= 1) return;

    titleContainers.forEach(function (titleBlock, index) {
      if (index === 0) return;
      var wrapper = titleBlock.closest('.product--title-container--mobile-true, .product--title-container--mobile-false');
      if (wrapper && wrapper.parentNode === inner) {
        wrapper.remove();
      } else {
        titleBlock.remove();
      }
    });
  }

  function cleanupAllHiddenPriceElements() {
    document.querySelectorAll('.product-card[data-hide-price="true"]').forEach(cleanupHiddenPriceCard);
    document.querySelectorAll('.thb-product-detail.product[data-hide-price="true"]').forEach(cleanupHiddenPriceProductDetail);
  }

  function scheduleCleanup() {
    clearTimeout(cleanupTimer);
    cleanupTimer = setTimeout(function () {
      cleanupAllHiddenPriceElements();
      dedupePdpTitleBlocks();
    }, 50);
  }

  document.addEventListener('DOMContentLoaded', scheduleCleanup);
  document.addEventListener('pagination:page-changed', function () {
    setTimeout(scheduleCleanup, 400);
  });

  [100, 300, 800, 1500, 3000].forEach(function (delay) {
    setTimeout(scheduleCleanup, delay);
  });
})();
